import { render, staticRenderFns } from "./modifyApplyBlock.vue?vue&type=template&id=20fc70e4&scoped=true&"
import script from "./modifyApplyBlock.vue?vue&type=script&lang=js&"
export * from "./modifyApplyBlock.vue?vue&type=script&lang=js&"
import style0 from "./modifyApplyBlock.vue?vue&type=style&index=0&id=20fc70e4&prod&lang=less&"
import style1 from "./modifyApplyBlock.vue?vue&type=style&index=1&id=20fc70e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc70e4",
  null
  
)

export default component.exports